import { useMemo } from "react"
import { usePreviewOrderBudgetQuery } from "shared/redux/endpoints/procurementApprovals"
import { ORDER_STATUS } from "../../status"
import OrderBudgetAllocation from "./OrderBudgetAllocation"

// Statuses whose lines are not yet committed to the budget. Once approved the
// commit is already in the figures, so adding the lines again would double count.
const UNCOMMITTED = [ORDER_STATUS.DRAFT, ORDER_STATUS.PENDING, ORDER_STATUS.INFO_REQUESTED]

const amountOf = (l) => l.amount ?? l.lineTotal ?? (Number(l.quantity) || 0) * (Number(l.unitPrice) || 0)

// Budget allocation of a saved order, from the same preview the order form uses.
const SavedOrderBudgetAllocation = ({ order, centerNameById }) => {
  const lines = useMemo(() => (order.lines || []).filter((l) => l.centerId), [order.lines])
  const categoryId = order.budgetCategoryId ?? order.category
  const args = useMemo(
    () =>
      categoryId && lines.length
        ? {
            budgetCategoryId: categoryId,
            orderForType: order.orderForType || undefined,
            orderForDates: order.orderForDates?.length ? order.orderForDates : undefined,
            lines: lines.map((l) => ({
              centerId: l.centerId,
              itemId: l.itemId ?? undefined,
              amount: amountOf(l),
              fiscalYear: l.fiscalYear ?? undefined,
              fiscalMonth: l.fiscalMonth ?? undefined,
            })),
          }
        : null,
    [categoryId, order.orderForType, order.orderForDates, lines]
  )
  const { currentData, isFetching, error } = usePreviewOrderBudgetQuery(args, { skip: !args })
  const lineInfo = lines.map((l, i) => ({
    cardNo: i + 1,
    itemName: l.itemName || l.offCatalogItemName,
    centerName: centerNameById?.get?.(String(l.centerId)) || centerNameById?.[l.centerId],
  }))
  return (
    <OrderBudgetAllocation
      rows={args ? currentData?.rows || [] : []}
      lineInfo={lineInfo}
      loading={isFetching}
      error={args ? error : null}
      uncommitted={UNCOMMITTED.includes(order.status)}
    />
  )
}

export default SavedOrderBudgetAllocation
